import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from '../constants';

export const useStyles = makeStyles(() => ({
  link: {
    fontSize: 12,
    fontWeight: 500,
    color: COLORS.inherited,
    padding: '6px 12px',
    borderRadius: 6,
    background: COLORS.inheritedLt,
    cursor: 'pointer',
    flexShrink: 0,
    transition: 'color 0.15s ease, background 0.15s ease',
    border: `1px solid ${COLORS.inherited}`,
    fontFamily: 'inherit',
    '&:hover': {
      color: COLORS.primaryDark,
      background: COLORS.primaryLight,
      borderColor: COLORS.primary,
    },
  },
}));
